import {SessionCooldownPopupDefaultBox} from "./session-cooldown-popup.default.box";

export const SessionCooldownPopupBox = SessionCooldownPopupDefaultBox;
